import React from "react";
import PropTypes from "prop-types";
import {getDataAttributes} from "./Component";
import ConfirmationDialog from "./ConfirmationDialog";
import {useModal} from "../../hooks/modal/ModalProvider";
import {useTranslation} from "react-i18next";

const ConfirmableButton = (props) => {
const {t} = useTranslation();

    const _className = () => {
        return (props.className ? " " + props.className : "")
            + (props.color ? " is-" + props.color : "")
            + (props.size ? " is-" + props.size : "")
            + (props.isLight ? " is-light" : "")
            + (props.isOutlined ? " is-outlined" : "")
            + (props.isRounded ? " is-rounded" : "")
            + (props.isLoading ? " is-loading" : "")
            + (props.isFullWidth ? " is-fullwidth" : "")
            + (props.isInverted ? " is-inverted" : "")
            + (props.isHiddenMobile ? " is-hidden-mobile" : "")
            + (props.hidden ? " is-hidden" : "")
            + (props.dataTooltip ? " has-tooltip" : "")
            + (props.dataTooltipAlign ? " " + props.dataTooltipAlign : "")
            ;
    }

    const { openModal, closeModal } = useModal();

    const handleClick = () => {
        if (shouldShowConfirm()) {
            openModal(
                {body: <ConfirmationDialog
                    onConfirm={handleConfirm}
                    onCancel={handleCancel}
                    confirmButtonText={props.confirmButtonText ?? t("dialog.yes")}
                    cancelButtonText={props.cancelButtonText ?? t("dialog.no")}
                    message={props.confirmMessage ?? t("dialog.confirm")}
                    additionalInfo={props.additionalInfo}
                />,
                title: t("dialog.confirm") ?? "Confirm",
                backdropClose: true}
            );
        } else {
            handleConfirm();
        }
    };
    const shouldShowConfirm = () => {
        // If shouldConfirm is a function, evaluate it, otherwise return its boolean value
        return typeof props.shouldConfirm === 'function' ? props.shouldConfirm() : props.shouldConfirm;
    };
    const handleConfirm = () => {
        props.onClick && props.onClick();
        closeModal();

    };

    const handleCancel = () => {
        closeModal();
    };
    return (
        <button type={props.isSubmit ? "submit" : props.isReset ? "reset" : "button"}
                onClick={handleClick}
                id={props.id}
                disabled={props.disabled || props.isLoading || false}
                className={"button " + _className()}
                data-tooltip={props.dataTooltip}
                {...getDataAttributes(props)}>
            {props.icon && <span className={"icon solid " + props.icon}></span>}
            {props.label}
        </button>
    )
}

ConfirmableButton.propTypes = {
    label: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,
    color: PropTypes.oneOf(["primary", "secondary", "link", "info", "success", "warning", "danger", "white", "light", "dark", "black", "text", "default"]),
    isLight: PropTypes.bool,
    isOutlined: PropTypes.bool,
    isRounded: PropTypes.bool,
    isLoading: PropTypes.bool,
    isInverted: PropTypes.bool,
    isFullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    size: PropTypes.oneOf(["small", "normal", "medium", "large"]),
    isSubmit: PropTypes.bool,
    isReset: PropTypes.bool,
    className: PropTypes.string,
    isHiddenMobile: PropTypes.bool,
    dataTooltip: PropTypes.string,
    dataTooltipAlign: PropTypes.string,
    id: PropTypes.string,
    confirmMessage: PropTypes.string,
    confirmButtonText: PropTypes.string,
    cancelButtonText: PropTypes.string,
    shouldConfirm: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export default ConfirmableButton;
